import axios from "axios";
import HostService from "./host.service";
import AuthService from "./auth.service";
import Columna from "../models/Columna";
import Tarea from "../models/Tarea";
import Comentario from "../models/Comentario";

class AgendaService {

    static async listarColumnas() {
        return axios
            .get(HostService.getHost() + 'agenda/columnas', AuthService.setToken())
            .then((res) => (Array.isArray(res.data) ? res.data : res.data?.items ?? []).map(Columna.from))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async crearColumna(columna /* Columna */) {
        return axios
            .post(HostService.getHost() + 'agenda/columnas', columna.toObject(), AuthService.setToken())
            .then((res) => Columna.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async renombrarColumna(id, name) {
        return axios
            .put(HostService.getHost() + 'agenda/columnas/' + encodeURIComponent(id), { nombre:name }, AuthService.setToken())
            .then((res) => Columna.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async eliminarColumna(id) {
        return axios
            .delete(HostService.getHost() + 'agenda/columnas/' + encodeURIComponent(id),  {
                params: { dropStrategy: 'delete' },
                ...AuthService.setToken()
            })
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e })
    }

    static async reordenarColumnas(order /* string[] */) {
        return axios
            .post(HostService.getHost() + 'agenda/columnas/reordenar', { orden:order }, AuthService.setToken())
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e })
    }

    // ---------- Tareas ----------
    static async crearTarea(tarea /* Tarea */) {
        return axios
            .post(HostService.getHost() + 'agenda/tareas', tarea.toObject(), AuthService.setToken())
            .then((res) => Tarea.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async obtenerTarea(id) {
        return axios
            .get(HostService.getHost() + 'agenda/tareas/' + encodeURIComponent(id), AuthService.setToken())
            .then((res) => Tarea.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async actualizarTarea(tarea /* Tarea */) {
        return axios
            .put(HostService.getHost() + 'agenda/tareas/' + encodeURIComponent(tarea.id), tarea.toObject(), AuthService.setToken())
            .then((res) => Tarea.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async eliminarTarea(id) {
        return axios
            .delete(HostService.getHost() + 'agenda/tareas/' + encodeURIComponent(id), AuthService.setToken())
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e })
    }

    static async moverTarea(id, toColumnId, toIndex) {
        return axios
            .post(
                HostService.getHost() + 'agenda/tareas/' + encodeURIComponent(id) + '/mover',
                { toColumnId, toIndex },
                AuthService.setToken()
            )
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e })
    }

    static async reordenarTarea(columnaId, taskIds /* string[] */) {
        return axios
            .post(
                HostService.getHost() + 'agenda/tareas/columna/' + encodeURIComponent(columnaId) + '/reordenar',
                { taskIds },
                AuthService.setToken()
            )
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e })
    }

    // ---------- Comentarios ----------
    static async crearComentario(comentario /* Comentario */) {
        return axios
            .post(HostService.getHost() + 'agenda/comentarios', comentario.toObject(), AuthService.setToken())
            .then((res) => Comentario.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async obtenerComentario(id) {
        return axios
            .get(HostService.getHost() + 'agenda/comentarios/' + encodeURIComponent(id), AuthService.setToken())
            .then((res) => Comentario.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async actualizarComentario(comentario /* Comentario */) {
        return axios
            .put(
                HostService.getHost() + 'agenda/comentarios/' + encodeURIComponent(comentario.id),
                comentario.toObject(),
                AuthService.setToken()
            )
            .then((res) => Comentario.from(res.data))
            .catch((e) => { console.log(e.message); throw e })
    }

    static async eliminarComentario(id) {
        return axios
            .delete(HostService.getHost() + 'agenda/comentarios/' + encodeURIComponent(id), AuthService.setToken())
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e })
    }
}

export default AgendaService;